<template>
    <div>
      <label for="finalidade" class="required">Finalidade da Viagem:</label>
      <select v-model="selected" @change="enviarEmit" id="finalidade">
        <option v-for="f in finalidades" :key="f.id" :value="f.descricao">
          {{ f.descricao }}
        </option>
      </select>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Finalidade',
    emits: ['finalidade-selecionada'],
    props: {
      valor: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        finalidades: [],
        selected: ''
      };
    },

    methods: {

      async getFinalidades() {
            try {
                const path = '/finalidade';
                const response = await this.$axios.get(path);
                this.finalidades = response.data;
            } catch (error) {
                if (error.response) {
                    console.error('(buscando finalidades) Resposta do servidor com status:', error.response.status);
                } else {
                    console.error('(buscando finalidades) Erro sem resposta do servidor:', error.message);
                }
            }
        },

    enviarEmit() {
        this.$emit('finalidade-selecionada', this.selected);
      }
    },

    mounted() {
      this.getFinalidades();
    },

  };
  </script>
  
  <style scoped>
  /* Adicione estilos específicos para o componente aqui, se necessário */
  </style>